import svg4everybody from 'svg4everybody';

export default class Global {
  init() {
    svg4everybody();
  }
}
